import { useState } from "react";

import AvatarWithAudio from "../avatars/avatarWithAudio";
import RecordResponse from "../recordresponse";
import Response from "../learning_module/response";
import VectorIcon from "../vectorIcon";

const audioUrl = "https://files.flowspeak.io/files/speak-like-a-pro.mp3";


function InteractiveWelcomeBody(props) {

  // Define variables
  const [status, setStatus] = useState('record'); // record, feedback, tryAgainStart, tryAgain
  const [response, setResponse] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const closeModal = props.closeModal;
  const setStep = props.setStep;


  // Define functions
  function handleTranscript(transcript, audioBlobUrl, blob, responseObject) {
    setResponse(responseObject);
    setStatus('feedback');
  }

  function handleTranscriptTwo(transcript, audioBlobUrl, blob, responseObject) {
    setStep(2);
  }

  function tryAgain() {
    const newRetryCount = retryCount + 1;
    setRetryCount(newRetryCount);

    setStatus('tryAgain');
  }


  // Screen components
  const closeElement = (
    <button onClick={closeModal}>
      <VectorIcon icon='close' />
    </button>
  );

  let howItWorksRight = <span class='icon'>&nbsp;</span>;

  let headerElement;
  let stepText;
  let stepDirections;
  let recordElement;
  let responseElement;
  let extraClass;
  let footerElement;

  if( status === 'record' ) {
    headerElement = (
      <div class='interactive-welcome-header'>
        <div class='flex-row'>
          <span class='icon'>&nbsp;</span>
          <h2>Let's Do This!</h2>
          {closeElement}
        </div>
        <p class='has-text-centered'>Before you start, let's learn how <span class='nobr'>FLOW Speak works</span></p>
      </div>
    );

    stepText = 'Step 1: Record your answer';
    stepDirections = 'Tap the button below, say your answer, and tap again to stop';

    recordElement = (
      <RecordResponse
        handleTranscript={handleTranscript}
        processingWords={['Scoring Fluency', 'Checking Speed', 'Analyzing Grammar']}
        messages={[]}
        colorScheme={'big'}
      />
    );
  }

  if( status === 'feedback' && response ) {
    extraClass = 'feedback';
    stepText = 'Step 2: Check your feedback';
    stepDirections = 'Tap the score to see your feedback details';
    howItWorksRight = closeElement;

    responseElement = (
      <div>
        <Response
          tryAgain={tryAgain}
          questionId={0}
          responseText={response.transcript}
          responseBlobUrl={response.audioFileUri}
          responseObject={response}
          handleTranscript={handleTranscriptTwo}
          retryLimit={3}
          retryCount={retryCount}
          lastMessage={''}
          allowRepeat={true}
        />
        <div class='interactive-welcome-feedback-arrow-container'>
          <div class='interactive-welcome-feedback-arrow'>
            <VectorIcon
              icon='chevronUp'
              // color={'active'}
              size={'2.5rem'}
            />
          </div>
          <p>Click here to see your feedback</p>
        </div>
      </div>
    );

    footerElement = (
      <button
        type='button'
        class='interactive-welcome-footer'
        onClick={() => setStatus('tryAgainStart')}
        title='Go to the next step'
      >
        Next Step
      </button>
    );
  }


  if( status === 'tryAgainStart' ) {
    stepText = 'Step 3: Try again';
    stepDirections = 'Want a higher score? Tap to retry.';
    howItWorksRight = closeElement;

    // Get the width of the response-content
    const responseWrapperElement = document.querySelector('.response-wrapper');
    const responseContentElement = document.querySelector('.response-content');
    let offset = 0;

    if( responseWrapperElement && responseContentElement ) {
      offset = responseWrapperElement.offsetWidth - responseContentElement.offsetWidth;
    }

    responseElement = (
      <div>
        <Response
          tryAgain={tryAgain}
          questionId={0}
          responseText={response.transcript}
          responseBlobUrl={response.audioFileUri}
          responseObject={response}
          handleTranscript={handleTranscriptTwo}
          retryLimit={3}
          retryCount={retryCount}
          lastMessage={''}
          allowRepeat={true}
        />
        <div class='interactive-welcome-try-again-arrow-container' style={{marginLeft: offset}}>
          <div class='interactive-welcome-try-again-arrow'>
            <VectorIcon icon='chevronUp' size={'2.5rem'} />
          </div>
          <p>Click here to try again</p>
        </div>
      </div>
    );
  }

  if( status === 'tryAgain' ) {
    stepText = 'Step 3: Try again';
    stepDirections = 'Want a higher score? Try again.';
    howItWorksRight = closeElement;

    recordElement = (
      <RecordResponse
        handleTranscript={handleTranscriptTwo}
        processingWords={['Scoring Fluency', 'Checking Speed', 'Analyzing Grammar']}
        messages={[]}
        colorScheme={'big'}
      />
    );
  }


  return (
    <div class='flex-column interactive-welcome-container fade-in-on-load'>
      {/* <div style={{width: '100%'}}> */}
      <div class='flex-column' style={{flexGrow: 1}}>
        {headerElement}

        <div class={`flex-column interactive-welcome-body ${extraClass}`}>
          <div>

            <div style={{marginBottom: '30px'}}>
              <div class='flex-row' style={{marginBottom: '15px'}}>
                <span class='icon'>&nbsp;</span>
                <h3>How It Works</h3>
                {howItWorksRight}
              </div>
              <h4 class='has-text-centered'>{stepText}</h4>
              <p class='has-text-centered'>{stepDirections}</p>
            </div>

            <div>
              <div class='aitalk-message-container assistant'>
                <AvatarWithAudio
                  type='assistant'
                  avatarUrl={'https://files.flowspeak.io/files/ai-speakers/man-one.png'}
                  audioUrl={audioUrl}
                  // message={'Testing message'}
                  // speakerId={1}
                  hasPremium={true}
                />

                <div>
                  <div class='flex-row aitalk-message'>
                    <p>Are you ready to speak English like a pro?</p>
                  </div>
                </div>
              </div>

              {responseElement}
            </div>
          </div>

          <div>
            {recordElement}
          </div>

        </div>
      </div>

      {footerElement}
    </div>
  );
}

export default InteractiveWelcomeBody;